import { useReducer } from 'react';
import { notificationsReducer } from './notificationsReducer';
import { NotificationsContext } from './notificationsContext';
import { UPDATE_NOTIFICATIONS_DATA } from './types';

export const NotificationsState = (props) => {

    const initialState = {
        notificationsData: {
            unreadNotifications: false,
        }
    }

    const [state, dispatch] = useReducer(notificationsReducer, initialState);

    const updateNotificationsData = (data) => {
        dispatch({
            type: UPDATE_NOTIFICATIONS_DATA,
            payload: data
        });
    }

    return (
        <NotificationsContext.Provider value={
            {
                notificationsData: state.notificationsData,
                updateNotificationsData
            }}>
            {props.children}
        </NotificationsContext.Provider>
    )
}


